import React from 'react';
import Features from '../components/sections/Features';
import PageHeader from '../components/ui/PageHeader';
import './StaticPage.css';

const FeaturesPage: React.FC = () => (
  <div className="static-page">
    <PageHeader page="features" />
    <Features />
  </div>
);

export default FeaturesPage;
